import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminCategoriasDocumentoPage } from "@/features/admin-categorias-documento/components/AdminCategoriasDocumentoPage";
import { categoriasDocumentoAdminQueryOptions } from "@/features/admin-categorias-documento/hooks/use-categorias-documento-admin";

/** Ruta `/admin/categorias-documento` · CRUD del catálogo de categorías de documento. */
export const Route = createFileRoute("/_authed-tw/admin/categorias-documento")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(categoriasDocumentoAdminQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminCategoriasDocumento]}>
      <AdminCategoriasDocumentoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
